export const T = {
  bg:'#0d0b1e', card:'#151230', elem:'#1c1640', hover:'#221a4a',
  border:'#2d1f6e', borderActive:'#7c3aed',
  violet:'#a78bfa', violetDark:'#7c3aed', violetDeep:'#4f46e5',
  violetGlow:'rgba(124,58,237,0.25)',
  green:'#4ade80', greenGlow:'rgba(74,222,128,0.15)',
  amber:'#fbbf24', amberGlow:'rgba(251,191,36,0.15)',
  red:'#f87171', redGlow:'rgba(248,113,113,0.15)',
  cyan:'#22d3ee',
  text:'#e2e8f0', muted:'#6b7280', faint:'#374151',
  gradPrimary:'linear-gradient(135deg,#7c3aed,#4f46e5)',
  gradCard:'linear-gradient(135deg,#1c1640,#151230)',
  gradHero:'linear-gradient(135deg,#2d1f6e 0%,#1c1640 40%,#0d0b1e 100%)',
  fontDisplay:"'Syne',sans-serif",
  fontBody:"'DM Sans',sans-serif",
  fontMono:"'JetBrains Mono',monospace",
  shadow:'0 4px 24px rgba(0,0,0,0.4)',
  shadowGlow:'0 0 24px rgba(124,58,237,0.3)',
};
